'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-console */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PxSConverter
 */

// Change this invariant to be a warning
var invariant = function invariant(arg, msg) {
  if (!arg) {
    console.warn(msg);
  }
};

var videoNodeBoundsCollection = [];
function clearNodeBoundsCache() {
  videoNodeBoundsCollection = [];
}

function videoWidthNodeBounds(id) {
  if (videoNodeBoundsCollection[id]) {
    return videoNodeBoundsCollection[id];
  }

  var node = document.querySelector('[data-js-video-' + id + ']');
  if (node) {
    videoNodeBoundsCollection[id] = node.getBoundingClientRect();
  }

  var mockBounds = {
    left: 0,
    width: 200
  };

  return mockBounds;
}

/*
 * based on a pixel value of the screens width
 * it should give you back the left pixel value relative
 * to the video width bounds
 */
function pxRelativeToVideoWidth(pixels, id) {
  return pixels - videoWidthNodeBounds(id).left;
}

/*
 * based on a pixel value of the screens width
 * it should give you back the time that it represents
 * in the video
 */
function pxToMs(pixels, durationMs, id) {
  var nodeBoundingRect = videoWidthNodeBounds(id);
  var top = nodeBoundingRect.width;
  var relativePixels = pixels - nodeBoundingRect.left;

  if (relativePixels <= 0) {
    return 0;
  }

  if (process.env.NODE_ENV !== 'production') {
    // guard against values larger than the body
    invariant(relativePixels <= top, 'PxSConverter: The value \'' + relativePixels + '\' is larger than the window. This results in innacurate values.');

    // guard against negative values
    invariant(relativePixels > 0, 'PxSConverter: The value \'' + relativePixels + '\' can not be negative.');
  }

  var pxPercent = relativePixels / top;

  return durationMs * pxPercent;
}

/*
 * based on a time in the video, it should give you the
 * `y` access coordinate for that time
 */
function msToPx(ms, durationMs, id) {
  if (process.env.NODE_ENV !== 'production') {
    // guard against values larger than duration
    invariant(ms <= durationMs, 'PxSConverter: The value \'' + ms + '\' is larger than the videos duration. ' + 'This results in inaccurate dom representations.');

    // guard against negative values
    invariant(ms >= 0, 'PxSConverter: The value \'' + ms + '\' can not be negative.');
  }

  if (ms <= 0.1) {
    return 0;
  }

  var top = durationMs;
  var msPercent = ms / top;
  var nodeBoundingRect = videoWidthNodeBounds(id);
  var docTop = nodeBoundingRect.width;

  return docTop * msPercent + nodeBoundingRect.left;
}

/*
 * based on a time in the video, it should give you the
 * percentage of the video that has progressed for that time
 */
function msToPercent(ms, durationMs) {
  if (process.env.NODE_ENV !== 'production') {
    // guard against values larger than duration
    invariant(ms <= durationMs, 'PxSConverter: The value \'' + ms + '\' is larger than the videos duration. ' + 'This results in inaccurate dom representations.');

    // guard against negative values
    invariant(ms >= 0, 'PxSConverter: The value \'' + ms + '\' can not be negative.');
  }

  if (ms <= 0.1) {
    return 0;
  }
  var top = durationMs;
  var msPercent = ms / top;
  return msPercent * 100;
}

exports.pxRelativeToVideoWidth = pxRelativeToVideoWidth;
exports.pxToMs = pxToMs;
exports.msToPx = msToPx;
exports.msToPercent = msToPercent;
exports.clearNodeBoundsCache = clearNodeBoundsCache;